// Store di Vue. Qui vengono inizializzati i Service, Keycloak(IDP), recuperate e
// centralizzate le informazioni relative al votante e all'evento elettorale.

import Vue from "vue";
import Vuex from "vuex";
import CeoCbbService from "../services/CeoCbbService";
import i18n from "../i18n";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    ceoCbbService: null,
    voterIdentification: null,
    electionEvent: null,
    alertMessage: i18n.t("error.verify-support-contact"),
    eventNumber: 0,
    logoutUrl: null
  },
  getters: {
    getCeoCbbService: state => {
      //console.debug("[store:getCeoCbbService]", state.ceoCbbService);
      return state.ceoCbbService;
    },
    getvoterIdentification: state => {
      return state.voterIdentification;
    },
    getElectionEvent: state => {
      return state.electionEvent;
    },
    getAlertMessage: state => {
      return state.alertMessage;
    },
    geteventNumber: state => {
      return state.eventNumber;
    },
    getLogoutUrl: state => {
      return state.logoutUrl;
    }
  },
  mutations: {
    ceoCbbServiceSetter(state, ma) {
      state.ceoCbbService = ma;
    },
    voterIdentificationSetter(state, vi) {
      state.voterIdentification = vi;
    },
    electionEventSetter(state, ee) {
      state.electionEvent = ee;
    },
    alertMessageSetter(state, ee) {
      state.alertMessage = ee;
    },
    eventNumberSetter(state, ee) {
      state.eventNumber = ee;
    },
    logoutUrlSetter(state, ee) {
      state.logoutUrl = ee;
    }
  },
  actions: {
    init: async (context, keycloak) => {
      // console.log("[store:init] inizializion CeoCbbService");
      const service = new CeoCbbService(keycloak);
      service.alertContactsSetter(context.state.alertMessage);
      context.commit("ceoCbbServiceSetter", service);
      //console.log("getting voter infomations");
      // let voterIdentification = await service.voterIdentification();

      // //console.log(voterIdentification);

      // if (voterIdentification.error) {
      //   //console.error(voterIdentification.error);
      //   alert(voterIdentification.error + "\n\n" + context.state.alertMessage);
      //   keycloak.logoutFn();
      // } else context.commit("voterIdentificationSetter", voterIdentification);

      ///////
      // let electionEvent = await service.getElectionEvent(
      //   context.state.voterIdentification.EventIdentifier.Id
      // );

      // if (electionEvent.error) {
      //   //console.error(electionEvent.error);
      //   alert(electionEvent.error + "\n\n" + context.state.alertMessage);
      //   return;
      // } else context.commit("electionEventSetter", electionEvent);

      // if (
      //   electionEvent.HelpDeskInformation != null &&
      //   electionEvent.HelpDeskInformation.ContactInformation != null &&
      //   electionEvent.HelpDeskInformation.ContactInformation.PhoneNumber != null
      // ) {
      //   context.commit(
      //     "alertMessageSetter",
      //     i18n.t("error.support-contact") +
      //       "\n" +
      //       i18n.t("error.telephone") +
      //       ": " +
      //       electionEvent.HelpDeskInformation.ContactInformation.PhoneNumber
      //   );
      //   service.alertContactsSetter(context.state.alertMessage);
      //   if (
      //     electionEvent.HelpDeskInformation.ContactInformation[
      //       "e-mailAddress"
      //     ] != null
      //   ) {
      //     context.commit(
      //       "alertMessageSetter",
      //       i18n.t("error.support-contact") +
      //         "\n" +
      //         i18n.t("error.telephone") +
      //         ": " +
      //         electionEvent.HelpDeskInformation.ContactInformation.PhoneNumber +
      //         "\nE-mail: " +
      //         electionEvent.HelpDeskInformation.ContactInformation[
      //           "e-mailAddress"
      //         ]
      //     );
      //     service.alertContactsSetter(context.state.alertMessage);
      //   }
      // }
    }
    // destroy:(context)=>{

    // }
  },
  modules: {}
});
